import React, { useEffect, useState } from "react";
import { DragDropContext, Draggable } from "react-beautiful-dnd";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import styled from "styled-components";
import Column from "../Column";
const Cards = styled.div`
  display: flex;
  justify-content: space-between;
`;
export default function (props) {
  const { agents } = props;
  const onDragEnd = (result) => {
    console.log(result);
  };

  const [data, setData] = useState({
    tasks: {},
    columns: {
      "column-1": {
        id: "column-1",
        title: "Travaux entrants",
        tasksIds: [],
      },
    },
  });

  const createAgentsColumn = () => {
    let columns = {};
    agents.map((agent, id) => {
      columns["agent-" + agent.id] = {
        id: "agent-" + agent.id,
        title: agent.first_name,
        tasksIds: [],
      };
    });

    console.log("liste des column");
  };

  useEffect(() => {
    createAgentsColumn();
  }, []);

  return (
    <Cards>
      <NotificationContainer />
      <DragDropContext onDragEnd={onDragEnd}>
        <Column
          key={data.columns["column-1"].id}
          column={data.columns["column-1"]}
          tasks={data.columns["column-1"].tasksIds.map(
            (taskId) => data.tasks[taskId]
          )}
        />
      </DragDropContext>
    </Cards>
  );
}
